/**
 * The calendar month before `today`, 1-indexed (MONTHS_OPTIONS codes + backend).
 * Validation runs after a month has closed, so forms default to the previous month.
 */
export const previousMonthPeriod = (today: Date = new Date()) => {
  const month = today.getMonth(); // 0-indexed current month == 1-indexed previous month
  return month === 0
    ? { month: 12, year: today.getFullYear() - 1 }
    : { month, year: today.getFullYear() };
};
